import { buildProps as o } from "./index601.js";
const t = [
  "dialog",
  "grid",
  "group",
  "listbox",
  "menu",
  "navigation",
  "tooltip",
  "tree"
], r = o({
  role: {
    type: String,
    values: t,
    default: "tooltip"
  }
});
export {
  r as popperProps,
  t as roleTypes
};
